import { Button, Stack, Typography } from "@compass/core";
import { isAuthorized } from "services";
import { createTextingConversationsPageRoute, CreateTextingConversationsPageState } from "../CreateTextingConversationsPage/CreateTextingConversationsPage";
import { LkPersonTypeId, Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";

export const TextingConversationsPageHeader = (props: { handle: string }) => {
  const navigate = useNavigate();
  const ROOT_PERMISSION: Permission = Permission.Texting;

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        <Typography variant="inherit">{props.handle}</Typography>

        <Stack direction="row" alignItems="center" spacing="sm">
          {isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && (
            <Button onClick={() => navigate(createTextingConversationsPageRoute.getPath(), { state: { personTypeId: Number(LkPersonTypeId.Student), personIds: [] } as CreateTextingConversationsPageState })} variant="outlined">
              + New
            </Button>
          )}
        </Stack>
      </Stack>

    </Stack>
  );
};
